import { Pipe, PipeTransform } from '@angular/core';
import {
  FIELD_TYPE_ATTACHMENT,
  FIELD_TYPE_BOOLEAN, FIELD_TYPE_COORDINATE, FIELD_TYPE_DATE, FIELD_TYPE_IMAGE, FIELD_TYPE_NAME, FIELD_TYPE_NUMBER,
  FIELD_TYPE_STRING, FIELD_TYPE_TIMESTAMP, FIELD_TYPE_UDF, FIELD_TYPE_ZONE
} from "../../app/app.constants";
import {isUndefined} from "ionic-angular/util/util";

/**
 * Generated class for the FormatDataTypePipe pipe.
 *
 * See https://angular.io/api/core/Pipe for more info on Angular Pipes.
 */
@Pipe({
  name: 'formatDataType',
})
export class FormatDataTypePipe implements PipeTransform {

  /**
   * Transforms the value depending on the label and dataType it corresponds to.
   * @param {string} label the label as shown in the list
   * @param value the value as returned by vizix
   * @param dataTypes is in the form: [{name: label, dataTypeId: 13}, .....]
   *              The server returns in the form [{nale: udf, dataTypeId: 13}] so before the pipe we transform
   *              to the form: [{name: label, dataTypeId: 13}, .....] using the labels or other information in the module.
   * @returns formatted value depending on the input type
   */

  transform(label: string, value: any, dataTypes: any) {
    let dataTypeId: number = null;

    // Iterate datatypes
    for (let dataType of dataTypes) {
      // Now we check if the label is in the dataTypeIds (it should)
      if (dataType.name == label) {
        dataTypeId = dataType.dataTypeId;
        break;
      }
    }

    if (dataTypeId) {
      // Here we check if the value is null or not
      if (value == null || value == 'null') {
        value = '';
      }

      switch (dataTypeId) {
        case FIELD_TYPE_NAME:
          return value;
        case FIELD_TYPE_STRING:
          return value;
        case FIELD_TYPE_COORDINATE:
          return value;
        case FIELD_TYPE_NUMBER:
          return String(value);
        case FIELD_TYPE_BOOLEAN:
          return value ? 'True' : 'False';
        case FIELD_TYPE_IMAGE:
          return value;
        case FIELD_TYPE_ZONE:
          return value;
        case FIELD_TYPE_DATE:
          if (!isUndefined(value.ts)) {
            return new Date(value.ts).toLocaleDateString() + ' ' + new Date(value.ts).toLocaleTimeString();
          } else {
            return '';
          }
        case FIELD_TYPE_TIMESTAMP:
          if (!isUndefined(value.ts)) {
            return new Date(value.ts).toLocaleDateString() + ' ' + new Date(value.ts).toLocaleTimeString();
          } else {
            return '';
          }
        case FIELD_TYPE_ATTACHMENT:
          return String(value);
        case FIELD_TYPE_UDF:
          return String(value);
        default:
          return String(value);
      }
    } else {
      return String(value);
    }
  }
}



// WEBPACK FOOTER //
// ./src/pipes/format-data-type/format-data-type.ts